import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Modal, Input, Typography } from 'antd';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Localization from '../../utils/localization';

import './styles.scss';
import EntitiesBrowser from '../EntitiesBrowser';
import { exportConfigActions } from '../../redux/actions';
import { getScenarioId } from '../../utils/scenarioIds';

const { Title } = Typography;

const ExportTemplateModal = ({ entities, businessCases, isModalOpen, handleClose }) => {
    const dispatch = useDispatch();
    const [checkedScenarios, setCheckedScenarios] = useState([]);
    const [checkedBusinessCases, setCheckedBusinessCases] = useState([]);
    const [expandedBusinessCases, setExpandedBusinessCases] = useState([]);
    const [templateName, setTemplateName] = useState('');
    const [templateDescription, setTemplateDescription] = useState('');
    const [templateIncludeBusinessCase, setTemplateIncludeBusinessCase] = useState(false);
    const [templateOnlyNonCalculatedValues, setTemplateOnlyNonCalculatedValues] = useState(false);

    const [checkedScenarioIds, setCheckedScenarioIds] = useState([]);       // for the tree UI
    const [selectedScenarioNodes, setSelectedScenarioNodes] = useState([]); // full objects for export
    const [checkedBusinessCaseIds, setCheckedBusinessCaseIds] = useState([]);

    
    // EntitiesBrowser -> modal callback
    const onCheckScenario = (nodes) => {
    if (!nodes) {
    setCheckedScenarioIds([]);
    setSelectedScenarioNodes([]);
    return;
  }
  const arr = Array.isArray(nodes) ? nodes : [nodes];

  const ids = [];
  const full = [];
  const seen = new Set();

  for (const n of arr.filter(Boolean)) {
    const id = getScenarioId(n);
    if (id == null || seen.has(id)) continue;
    seen.add(id);
    ids.push(id);
    full.push(Number.isInteger(n) ? { scenario_id: id } : n);
  }

  setCheckedScenarioIds(ids);
  setSelectedScenarioNodes(full);
};

const handleOk = () => {
  const template = {
    name: templateName,
    description: templateDescription,
    scenarios: checkedScenarioIds,
    businessCases: checkedBusinessCaseIds,
    resultBusinessCases: templateIncludeBusinessCase,
    nonCalculatedValuesOnly: templateOnlyNonCalculatedValues,
  };

  dispatch(exportConfigActions.createExportConfig(template));
  handleClose?.();
};

    const onCheckBusinessCase = (businessCase) => {

         const id = businessCase.business_case_id;
            setCheckedBusinessCaseIds((prev) =>
            prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
        );
        };
     /*   const index = checkedBusinessCases.findIndex((checkedCase) => {
            return checkedCase.business_case_id === businessCase.business_case_id;
        });

        let newCases = [...checkedBusinessCases];
        if (index === -1) {
            newCases.push(businessCase);
        } else {
            newCases = [...newCases.slice(0, index), ...newCases.slice(index + 1)];
        }
        setCheckedBusinessCases(newCases);
    };
*/
    const renderBusinessCases = (businessCases) => {
        const businessCheckboxes = businessCases.map((businessCase) => {
            return (
                <FormControlLabel
                    key={businessCase.business_case_id}
                    control={
                        <Checkbox
                            checked={checkedBusinessCaseIds.includes(businessCase.business_case_id)}
          onChange={(e) => { onCheckBusinessCase(businessCase); e.stopPropagation(); }}
                        />
                    }
                    label={businessCase.name}
                />
            );
        });
        return businessCheckboxes;
    };

    return (
        <Modal
            bodyStyle={{
                minHeight: '45vh',
                display: 'flex',
                flexDirection: 'column',
            }}
            title={Localization.export.exportTemplateModal}
            open={isModalOpen} // not deprecated in our version
            onOk={handleOk}
            confirmLoading={false}
            onCancel={handleClose}
        >
            <Input
                style={{
                    marginBottom: '10px',
                    maxWidth: '275px',
                    alignSelf: 'left',
                }}
                placeholder={Localization.export.templateName}
                onChange={(e) => {
                    setTemplateName(e.target.value);
                }}
                defaultValue={''}
            />
            <Input
                style={{
                    marginBottom: '15px',
                    maxWidth: '275px',
                    alignSelf: 'left',
                }}
                placeholder={Localization.export.templateDescription}
                onChange={(e) => {
                    setTemplateDescription(e.target.value);
                }}
                defaultValue={''}
            />
            <FormControlLabel
                style={{ marginBottom: '15px' }}
                control={
                    <Checkbox
                        checked={templateIncludeBusinessCase}
                        onChange={() => setTemplateIncludeBusinessCase(!templateIncludeBusinessCase)}
                    />
                }
                label={Localization.export.includeBusinessCaseResult}
            />
            <FormControlLabel
                style={{ marginBottom: '15px' }}
                control={
                    <Checkbox
                        checked={templateOnlyNonCalculatedValues}
                        onChange={() => setTemplateOnlyNonCalculatedValues(!templateOnlyNonCalculatedValues)}
                    />
                }
                label={Localization.export.nonCalculatedValuesOnly}
            />
            <Title level={4} style={{}}>
                Choose entities or scenarios:
            </Title>
            {entities ? (
                <EntitiesBrowser
                    entityStructure={entities}
                    handleCheck={onCheckScenario}
                    expandedBusinessCases={expandedBusinessCases}
                    setExpandedBusinessCases={setExpandedBusinessCases}
                    editable={false}
                    checkedNodes={checkedScenarioIds}
                    style={{ maxHeight: '100px' }}
                />
            ) : (
                'No entities found.'
            )}
            <Title level={4} style={{}}>
                Choose business cases:
            </Title>

            {renderBusinessCases(businessCases)}
        </Modal>
    );
};

export default ExportTemplateModal;
